import { render, staticRenderFns } from "./priceEdit.vue?vue&type=template&id=3d520554&scoped=true&"
import script from "./priceEdit.vue?vue&type=script&lang=js&"
export * from "./priceEdit.vue?vue&type=script&lang=js&"
import style0 from "./priceEdit.vue?vue&type=style&index=0&id=3d520554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d520554",
  null
  
)

export default component.exports